<mbs-wizard
  class="mbs-wizard_flex-content"
  [(ngModel)]="stepsManager.currentStep"
  [buttonLoadingMode]="true"
  [canClosed]="!loadingPlan && wizardFinish"
  [firstStepTitle]="mainService.firstStepTitle"
  [isOpenSteps]="!loadingPlan && isEdit"
  [loading]="loadingPlan"
  [ignoreSteps]="ignorableSteps"
  [stepsOrientation]="orientations"
  [cancelButton]="{ hide: false, text: 'shared:buttons.cancel' | i18next }"
  [saveButton]="{ text: 'shared:buttons.save' | i18next }"
  [stepQueue]="stepsManager.stepQueue"
  [stepMarks]="stepsManager.stepMarks"
  [stepsContainerClass]="mainService.isOffline ? 'fit-content' : ''"
  (closeModalEvent)="handleModalClose()"
  (save)="handleSave()"
  (next)="nextHandler($event)"
  (stepSelected)="stepSelectedHandler($event)"
  [title]="wizardTitle + ' ' + mainService.compName + ' | ' + (planName || '')">
  <div
    *ngIf="mainService.isOffline"
    prependStep
    class="pl-4 py-2 background-secondary">
    <span class="fa fa-power-off"></span> {{ prependStepText }}
  </div>
  <mbs-wizard-step
    [title]="'wizards:backupDestinationsTitle' | i18next"
    [documentationLink]="helpLink.links.mainLink"
    [valid]="FormModel?.whereBackupStep?.valid"
    (next)="whereBackupStep?.forceValid()">
    <mbs-where-backup-step
      #whereBackupStep
      [(ngModel)]="FormModel.whereBackupStep"
      (changeStorage)="storageManager.changeStorageHandler($event)"
      [Storages]="FormModel?.Storages"></mbs-where-backup-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [title]="'wizards:optionsStepTitle' | i18next"
    [documentationLink]="helpLink.links.mainLink"
    [valid]="FormModel?.compressionEncryptionStep?.valid"
    (next)="compressionEncryptionStep?.forceValid(stepsManager.currentStep)">
    <mbs-compression-encryption-step
      #compressionEncryptionStep
      [isS3Selected]="FormModel?.advancedOptionsFlags?.UseS3AccelerationPossible"
      [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.compressionEncryption"
      [SaveDeletedDataInCloud]="FormModel?.advancedOptionsStep?.SaveDeletedDataInCloud"
      (nextStep)="forceNextStepWizard(!!$event, 'compressionEncryptionStep', 'Compression & Encryption')"
      [(ngModel)]="FormModel.compressionEncryptionStep"></mbs-compression-encryption-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    *ngIf="stepsManager.useNewSchedule"
    [title]="stepsManager.titles.schedule"
    [documentationLink]="helpLink.links.mainLink"
    [valid]="FormModel?.scheduleStep?.valid"
    (next)="scheduleStepNBF?.forceValid(stepsManager.currentStep)">
    <mbs-nbf-schedule-step
      #scheduleStepNBF
      [title]="stepsManager.titles.schedule"
      [retentionTitle]="stepsManager.titles.retention"
      [(ngModel)]="FormModel.scheduleStep"
      [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.schedule"
      (changeType)="scheduleTypeChangeHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'scheduleStep', stepsManager.titles.schedule)"
      (selectStep)="stepsManager.setCurrentStep($event)"
      (addStepMark)="stepsManager.addStepMark($any($event))"
      (removeStepMark)="stepsManager.removeStepMark($any($event))"></mbs-nbf-schedule-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [title]="stepsManager.titles.schedule"
    [documentationLink]="helpLink.links.mainLink"
    [valid]="FormModel?.scheduleStep?.valid"
    (next)="scheduleStep?.forceValid(stepsManager.currentStep)">
    <mbs-schedule-step
      #scheduleStep
      [(ngModel)]="FormModel.scheduleStep"
      [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.schedule"
      (nextStep)="forceNextStepWizard(!!$event, 'scheduleStep', stepsManager.titles.schedule)"
      (incrementalData)="setIncrementalData($event)"
      (changeType)="scheduleTypeChangeHandler($event)"></mbs-schedule-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="FormModel?.scheduleStep?.ScheduleType === 'recurring'"
    [title]="'wizards:advanced_schedule_step_title' | i18next"
    [documentationLink]="helpLink.links.mainLink"
    [valid]="FormModel?.scheduleAdvancedStep?.valid"
    (next)="scheduleAdvancedStep?.forceValid()">
    <mbs-schedule-advanced-step
      #scheduleAdvancedStep
      [stepFocused]="stepsManager.currentStep?.title === ('wizards:advanced_schedule_step_title' | i18next)"
      [(ngModel)]="FormModel.scheduleAdvancedStep"></mbs-schedule-advanced-step>
  </mbs-wizard-step>
</mbs-wizard>
